import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';
import { UsersService, Contatti, ContattiService } from 'my-lib-sanfelici';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-contatti-details',
  templateUrl: './contatti-details.component.html',
  styleUrls: ['./contatti-details.component.scss']
})
export class ContattiDetailsComponent implements OnInit {
id: string;
contatto: Observable<Contatti>;
  constructor(
    private usersservice: UsersService,
    private db: AngularFirestore,
    private router: Router,
    private contattiservice: ContattiService,

    private route: ActivatedRoute) { }
    cancella(id) {
      this.contattiservice.delete(id).then(() => {
    this.router.navigate(['/myuser', 'contatti', 'details', id]);
      });
    }
  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.contatto = this.contattiservice.get(this.id);
    this.contatto.subscribe(c => {
  if (c) {} else {this.router.navigate(['/myuser', 'contatti', 'create', this.id]);}
});
  }

}
